<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerOff_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.833 2a.666.666 0 0 0-.533.267L4.029 5.294l-2.189.438C1.061 5.888.5 6.572.5 7.366v1.267c0 .794.561 1.478 1.34 1.634l2.19.438 2.27 3.028a.666.666 0 0 0 1.2-.4V2.667A.666.666 0 0 0 6.833 2Z"
    />
</svg>
